import script from "./GroupBy.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupBy.vue?vue&type=script&setup=true&lang=js"

import "./GroupBy.vue?vue&type=style&index=0&id=80ebf554&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80ebf554"]])

export default __exports__